import extractCountryCallingCode from "./helpers/extractCountryCallingCode.js";
import extractCountryCallingCodeFromInternationalNumberWithoutPlusSign from "./helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js";
import extractNationalNumberFromPossiblyIncompleteNumber from "./helpers/extractNationalNumberFromPossiblyIncompleteNumber.js";
import stripIddPrefix from "./helpers/stripIddPrefix.js";
import parseDigits from "./helpers/parseDigits.js";
import { VALID_PUNCTUATION, VALID_DIGITS, PLUS_CHARS } from "./constants.js";
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(o, minLen) {
  if (o) {
    if (typeof o == "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
}
function _arrayLikeToArray(arr, len) {
  (len == null || len > arr.length) && (len = arr.length);
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol < "u" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i != null) {
    var _arr = [], _n = !0, _d = !1, _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0)
        ;
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i.return != null && _i.return();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), Object.defineProperty(Constructor, "prototype", { writable: !1 }), Constructor;
}
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = "[" + VALID_PUNCTUATION + VALID_DIGITS + "]+", VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp("^" + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + "$", "i"), VALID_FORMATTED_PHONE_NUMBER_PART = "(?:[" + PLUS_CHARS + "][" + VALID_PUNCTUATION + VALID_DIGITS + "]*|[" + VALID_PUNCTUATION + VALID_DIGITS + "]+)", AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp("[^" + VALID_PUNCTUATION + VALID_DIGITS + "]+.*$"), COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/, AsYouTypeParser = /* @__PURE__ */ function() {
  function AsYouTypeParser2(_ref) {
    var defaultCountry = _ref.defaultCountry, defaultCallingCode = _ref.defaultCallingCode, metadata = _ref.metadata, onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;
    _classCallCheck(this, AsYouTypeParser2), this.defaultCountry = defaultCountry, this.defaultCallingCode = defaultCallingCode, this.metadata = metadata, this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }
  return _createClass(AsYouTypeParser2, [{
    key: "input",
    value: function(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text), _extractFormattedDigi2 = _slicedToArray(_extractFormattedDigi, 2), formattedDigits = _extractFormattedDigi2[0], hasPlus = _extractFormattedDigi2[1], digits = parseDigits(formattedDigits), justLeadingPlus;
      return hasPlus && (state.digits || (state.startInternationalNumber(), digits || (justLeadingPlus = !0))), digits && this.inputDigits(digits, state), {
        digits,
        justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(nextDigits, state) {
      var digits = state.digits, hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3;
      if (state.appendDigits(nextDigits), hasReceivedThreeLeadingDigits && this.extractIddPrefix(state), this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state))
          return;
      } else
        state.appendNationalSignificantNumberDigits(nextDigits);
      state.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
        return state.update(stateUpdate);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(_ref2) {
      var international = _ref2.international, callingCode = _ref2.callingCode;
      return international && !callingCode;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(state) {
      var _extractCountryCallin = extractCountryCallingCode("+" + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
      if (countryCallingCode)
        return state.setCallingCode(countryCallingCode), state.update({
          nationalSignificantNumber: number
        }), !0;
    }
  }, {
    key: "reset",
    value: function(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = !0;
        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(nationalDigits, setState) {
      if (this.hasSelectedNumberingPlan) {
        var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe.nationalPrefix, nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
        if (nationalNumber !== nationalDigits)
          return this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata), nationalPrefix = _extractNationalNumbe2.nationalPrefix, nationalNumber = _extractNationalNumbe2.nationalNumber, carrierCode = _extractNationalNumbe2.carrierCode;
        if (nationalNumber !== prevNationalSignificantNumber)
          return this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber, nationalSignificantNumberMatchesInput, nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber);
      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = !0;
        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex);
        prefixBeforeNationalNumber !== nationalPrefix && (complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber);
      }
      setState({
        nationalPrefix,
        carrierCode,
        nationalSignificantNumber,
        nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(state) {
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function(stateUpdate) {
        return state.update(stateUpdate);
      }))
        return !0;
      if (this.extractIddPrefix(state))
        return this.extractCallingCodeAndNationalSignificantNumber(state), !0;
      if (this.fixMissingPlus(state))
        return this.extractCallingCodeAndNationalSignificantNumber(state), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(state) {
      var international = state.international, IDDPrefix = state.IDDPrefix, digits = state.digits;
      if (state.nationalSignificantNumber, !(international || IDDPrefix)) {
        var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (numberWithoutIDD !== void 0 && numberWithoutIDD !== digits)
          return state.update({
            IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
          }), this.startInternationalNumber(state, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), newCallingCode = _extractCountryCallin2.countryCallingCode;
        if (_extractCountryCallin2.number, newCallingCode)
          return state.update({
            missingPlus: !0
          }), this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(state, _ref3) {
      var country = _ref3.country, callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode), state.nationalSignificantNumber && (state.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(state) {
      this.extractCountryCallingCode(state) && this.extractNationalSignificantNumber(state.getNationalDigits(), function(stateUpdate) {
        return state.update(stateUpdate);
      });
    }
  }]), AsYouTypeParser2;
}();
function extractFormattedPhoneNumber(text) {
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);
  if (!(startsAt < 0)) {
    text = text.slice(startsAt);
    var hasPlus;
    return text[0] === "+" && (hasPlus = !0, text = text.slice(1)), text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ""), hasPlus && (text = "+" + text), text;
  }
}
function _extractFormattedDigitsAndPlus(text) {
  var extractedNumber = extractFormattedPhoneNumber(text) || "";
  return extractedNumber[0] === "+" ? [extractedNumber.slice(1), !0] : [extractedNumber];
}
function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text), _extractFormattedDigi4 = _slicedToArray(_extractFormattedDigi3, 2), formattedDigits = _extractFormattedDigi4[0], hasPlus = _extractFormattedDigi4[1];
  return VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits) || (formattedDigits = ""), [formattedDigits, hasPlus];
}
export {
  AsYouTypeParser as default,
  extractFormattedDigitsAndPlus
};
//# sourceMappingURL=AsYouTypeParser.js.map
